import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { LoginPage } from './login/login.page';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { RegisterPage } from './register/register.page';
import { SharedModule } from '../shared-module/shared.module';
import { OpenPageGuard } from 'src/app/guards/open-page.guard';
import { VerifyEmailPage } from './verify-email/verify-email.page';
import { NewPasswordPage } from './new-password/new-password.page';
import { AuthRootComponent } from './auth-root/auth-root.component';
import { ComponentsModule } from '../../components/components.module';
import { ResetPasswordPage } from './reset-password/reset-password.page';
import { ForgotPasswordPage } from './forgot-password/forgot-password.page';
import { NotFoundComponent } from '../../components/not-found/not-found.component';

const authRoutes: Routes = [
  {
    path: '',
    component: AuthRootComponent,
    children: [
      { path: 'login', component: LoginPage, canActivate: [OpenPageGuard] },
      { path: 'reset', component: ResetPasswordPage, canActivate: [OpenPageGuard] },
      { path: 'newpassword', component: NewPasswordPage, canActivate: [OpenPageGuard] },
      { path: 'verify', component: VerifyEmailPage, canActivate: [OpenPageGuard] },
      { path: 'register', component: RegisterPage, canActivate: [OpenPageGuard] },
      { path: 'forgot', component: ForgotPasswordPage, canActivate: [OpenPageGuard] },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: '**', component: NotFoundComponent }
    ]
  },
];

@NgModule({
    declarations: [
        LoginPage,
        ForgotPasswordPage,
        ResetPasswordPage,
        AuthRootComponent,
        VerifyEmailPage,
        RegisterPage,
        NewPasswordPage
    ],
    imports: [
        IonicModule,
        CommonModule,
        ComponentsModule,
        ReactiveFormsModule,
        SharedModule,
        RouterModule.forChild(authRoutes),
    ],
    providers: []
})
export class AuthModule {

}
